import React from 'react';
import { Search } from 'shared/assets/icons';
import { IconButton } from 'shared/components/ui/icon-button';
import { useOpenSearchDialog } from 'shared/contexts/search';

export const SearchButton: React.FC = () => {
  const openSearchDialog = useOpenSearchDialog();

  return <IconButton icon={Search} onClick={openSearchDialog} />;
};
